import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'

export const ChatNotFound = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  return (
    <div className="flex flex-col items-center justify-center h-full grow text-content-muted">
      <div className="flex flex-col gap-2 items-center justify-center w-full sm:w-1/2">
        <SvgIcon
          name="status-warning"
          size="4x"
          className="text-content-muted"
        />
        <Text className="flex text-2xl font-semibold text-content-muted">
          <T
            id="Messaging.NotFound.Title"
            defaultMessage="Conversation not found"
          />
        </Text>
        <Text className="text-sm text-center text-content-muted font-normal">
          <T
            id="Messaging.NotFound.Description"
            defaultMessage="The conversation that you are looking for does not exist, is removed, or you don’t have permission to access it."
          />
        </Text>
        <Button
          variant="secondaryNeutral"
          className="sm:hidden mt-5"
          leadingIcon={<SvgIcon name="arrow-left" size="sm" />}
          onClick={() => {
            navigate(`/messaging?${searchParams.toString()}`)
          }}
        >
          <T
            id="Messaging.NotFound.BackToChats"
            defaultMessage="Back to chats"
          />
        </Button>
      </div>
    </div>
  )
}
